export default __webpack_public_path__ + "static/media/picsart.f869489b.svg";